// Rentinit's published Hazel conversation. A subject-specific API URL (jobs)
// takes precedence so it keeps the conversation selected by the backend.
export const HAZEL_WHATSAPP_URL = "https://wa.me/971503243260";

export interface HazelSubject {
  subject: string;
  reference?: string;
  details?: string;
  request?: string;
}

export function hazelWhatsAppUrl(
  context: HazelSubject,
  destination = HAZEL_WHATSAPP_URL,
): string | null {
  try {
    const url = new URL(destination);
    if (
      url.protocol !== "https:" ||
      !["wa.me", "api.whatsapp.com", "web.whatsapp.com"].includes(url.hostname)
    )
      return null;
    // Keep existing routing instructions from the backend as well as context.
    const existing = url.searchParams.get("text");
    url.searchParams.set(
      "text",
      [
        existing,
        context.request ??
          `Hi Hazel, I have a question about ${context.subject}.`,
        context.details,
        context.reference ? `Reference: ${context.reference}` : null,
      ]
        .filter(Boolean)
        .join("\n\n"),
    );
    return url.toString();
  } catch {
    return null;
  }
}
